/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */
// @mui material components
import { Dialog, DialogActions, DialogTitle, Icon, IconButton } from "@mui/material";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";

// Material Dashboard 2 React components

import MDTypography from "components/MDTypography";
import MDBadge from "components/MDBadge";
import { useMaterialUIController, setSuccessSB, setErrorSB } from "context";
import useLocale from "context/useLocale";
import { useState, useEffect } from "react";
import Moment from "react-moment";
import { Link, useParams } from "react-router-dom";

import {
  fetchAll,
  deleteById,
  setFeaturedById,
  renewInactiveListingById,
} from "services/VehicleEntries";
import { fetchById } from "services/Showrooms";

export default function data() {
  const locale = useLocale();
  const [, dispatch] = useMaterialUIController();
  const [rows, setRows] = useState([]);
  const [searchParams, setSearchParams] = useState({ price: "", approved: "" });
  const [sortBy, setSortBy] = useState("updated_at");
  const [sortOrder, setSortOrder] = useState("desc");
  const [paginationMeta, setPaginationMeta] = useState({});
  const { showroomId } = useParams();
  const [open, setOpen] = useState([]);
  const [anchorEl, setAnchorEl] = useState({});
  const [showroomInfo, setShowroomInfo] = useState(null);

  // Fetch showroom info
  useEffect(() => {
    if (showroomId) {
      fetchById(showroomId).then(
        (res) => {
          setShowroomInfo(res.data.data);
        },
        (err) => setErrorSB(dispatch, `${err.response.data.error.message}`)
      );
    }
  }, [showroomId]);

  const handleDropDownMenuTriggerClick = (event, rowId) => {
    setAnchorEl((prev) => ({
      ...prev,
      [rowId]: event.currentTarget,
    }));
  };
  const handleCloseDropDownMenu = (rowId) => {
    setAnchorEl((prev) => ({
      ...prev,
      [rowId]: null,
    }));
  };
  const handleClickOpen = (id) => {
    const openCopy = [...open];
    openCopy[id] = true;
    setOpen(openCopy);
  };

  const handleClose = (id) => {
    const openCopy = [...open];
    openCopy[id] = false;
    setOpen(openCopy);
  };

  const handleSearchChange = (key) => (e) => {
    setSearchParams((prevParams) => ({
      ...prevParams,
      [key]: e.target.value,
    }));
  };

  const handleSortChange = (sortColumn) => {
    let newSortOrder = "asc";
    if (sortBy === sortColumn && sortOrder === "asc") {
      newSortOrder = "desc";
    }
    setSortBy(sortColumn);
    setSortOrder(newSortOrder);
  };

  const loadData = (page) => {
    fetchAll(
      {
        "seller.showroom_id": showroomId,
      },
      page,
      searchParams,
      sortBy,
      sortOrder
    ).then(
      (res) => {
        setRows(res.data.data.data);
        setPaginationMeta(res.data.data.meta.pagination);
      },
      (err) => setErrorSB(dispatch, `${err.response.data.error.message}`)(err)
    );
  };

  const handleDelete = (id) => {
    deleteById(id).then(
      (res) => {
        loadData(1);
        setSuccessSB(dispatch, `${res.data.data.title} vehicle entry has been removed`);
      },
      (err) =>
        setErrorSB(
          dispatch,
          `${
            err.response.data.message ? err.response.data.message : err.response.data.error.message
          }`
        )
    );
    handleClose(id);
  };

  const handleSetFeatured = (id) => {
    setFeaturedById(id).then(
      (res) => {
        loadData(1);
        setSuccessSB(dispatch, `${res.data.data.title} vehicle entry has been set as featured`);
      },
      (err) =>
        setErrorSB(
          dispatch,
          `${
            err.response.data.message ? err.response.data.message : err.response.data.error.message
          }`
        )
    );
  };

  const handleRenewInactiveListing = (id) => {
    renewInactiveListingById(id).then(
      (res) => {
        loadData(1);
        setSuccessSB(dispatch, `${res.data.data.title} vehicle entry has been renewed`);
      },
      (err) =>
        setErrorSB(
          dispatch,
          `${
            err.response.data.message ? err.response.data.message : err.response.data.error.message
          }`
        )
    );
  };

  useEffect(() => {
    if (showroomId) {
      loadData(1);
    }
  }, [showroomId, searchParams, sortBy, sortOrder]);

  const renderRows = rows.map((row) => ({
    id: row.id,
    title: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        {row.title}
      </MDTypography>
    ),
    mainImage: (
      <MDAvatar
        src={`${process.env.REACT_APP_STORAGE_PREFIX}/${row.main_image}`}
        alt={row.title}
        size="lg"
        variant="square"
      />
    ),
    price: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        {row.price}
      </MDTypography>
    ),
    approved: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        {row.approved}
      </MDTypography>
    ),
    status: (
      <>
        <MDBadge
          badgeContent={
            row.listing_period.is_active ? locale("activeListing") : locale("inActiveListing")
          }
          container
          color={row.listing_period.is_active ? "primary" : "warning"}
        />
        {row.listing_period.is_featured ? (
          <MDBadge badgeContent={locale("featuredVehicle")} container color="primary" />
        ) : null}
      </>
    ),
    created_at: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        <Moment format="DD-MMM-YYYY, hh:mm A">{row.created_at}</Moment>
      </MDTypography>
    ),
    updated_at: (
      <MDTypography component="p" variant="button" color="text" fontWeight="medium">
        <Moment format="DD-MMM-YYYY, hh:mm A">{row.updated_at}</Moment>
      </MDTypography>
    ),
    action: (
      <>
        <div>
          <IconButton onClick={(e) => handleDropDownMenuTriggerClick(e, row.id)}>
            <Icon fontSize="sm">
              <MoreVertIcon />
            </Icon>
          </IconButton>
          <Menu
            anchorEl={anchorEl[row.id]}
            open={Boolean(anchorEl[row.id])}
            onClose={() => handleCloseDropDownMenu(row.id)}
          >
            <MenuItem
              aria-label="edit"
              color="blue"
              component={Link}
              to={`/dashboard/vehicleEntry/${row.vehicle_type_id}/${row.vehicle_condition_id}/edit/${row.id}`}
            >
              {locale("edit")}
            </MenuItem>
            <MenuItem aria-label="delete" color="primary" onClick={() => handleClickOpen(row.id)}>
              {locale("delete")}
            </MenuItem>
            <MenuItem
              disabled={row.listing_period.is_active}
              aria-label="renew"
              color="primary"
              onClick={() => handleRenewInactiveListing(row.id)}
            >
              {locale("renewInactiveListing")}
            </MenuItem>
            <MenuItem
              disabled={!(row.listing_period.is_active && !row.listing_period.is_featured)}
              aria-label="setFeatured"
              color="primary"
              onClick={() => handleSetFeatured(row.id)}
            >
              {locale("setFeatured")}
            </MenuItem>
          </Menu>
        </div>
        <Dialog
          open={typeof open[row.id] !== "undefined" && open[row.id]}
          onClose={() => handleClose(row.id)}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <DialogTitle id="alert-dialog-title">
            {`Are you sure you want to delete (${row.title}) ?`}
          </DialogTitle>
          <DialogActions>
            <MDButton variant="contained" onClick={() => handleClose(row.id)}>
              {locale("cancel")}
            </MDButton>
            <MDButton variant="contained" color="error" onClick={() => handleDelete(row.id)}>
              {locale("confirm")}
            </MDButton>
          </DialogActions>
        </Dialog>
      </>
    ),
  }));

  return {
    columns: [
      { Header: locale("id"), accessor: "id" },
      { Header: locale("title"), accessor: "title" },
      { Header: locale("mainImage"), accessor: "mainImage" },
      { Header: locale("price"), accessor: "price", searchable: "true" },
      { Header: locale("approved"), accessor: "approved", searchable: "true" },
      { header: "status", accessor: "status" },
      { Header: locale("createdAt"), accessor: "created_at" },
      { Header: locale("updatedAt"), accessor: "updated_at" },
      { Header: locale("actions"), accessor: "action", align: "left" },
    ],
    rows: renderRows,
    paginationMeta,
    loadData,
    handleSearchChange,
    handleSortChange,
    showroomInfo,
  };
}
